import { Notification } from "@/Store/toast";

export default {
    methods: {
        /**
         * A handful proxy method to push notification to the global toast component
         *
         * @returns {{success: ((function(title: String, message: String): Notification)|*), warning: ((function(title: String, message: String): Notification)|*), error: ((function(title: String, message: String): Notification)|*), info: ((function(title: String, message: String): Notification)|*)}}
         */
        toast() {
            return {
                info: Notification.info,
                success: Notification.success,
                warning: Notification.warning,
                error: Notification.error,
            }
        },

        /**
         * A simple and nice error handel with logger support
         *
         * @param error
         * @param context
         * @param options
         */
        onHttpErrorDefaultHandler(error, context, options) {
            options = Object.assign({
                title: 'app.http_error',
                title_values: {},
                message: null,
                message_values: {},
                log_message: 'http error',
            }, options || {});

            this.toast().error(
                this.$t(options.title, options.title_values),
                options.message? this.$t(options.message, options.message_values) : null,
            );

            console.error(options.log_message, ...[error, context].filter(value => !!value));
        },
    }
}
